import { call, put, takeLatest } from "redux-saga/effects";
import { downloadXLSFile } from "utils/api";
import { ToastSuccess, ToastError, ToastInfo } from "components/Global/Toasts/Toasty";
import {
  defaultReturn
  , makePayload
  , generateDefaultActions
  , requestSaga
} from "shared-utility/store/utils/helpers";

// ACTIONS
export const WHAT_IF_CALCULATOR_EXPORT = generateDefaultActions("WHAT_IF_CALCULATOR_EXPORT");
export const exportWhatIf = payload => makePayload(WHAT_IF_CALCULATOR_EXPORT.value, payload);
function* exportWhatIfSaga(payload) {
  const url = "/exportWhatIf";
  yield call(downloadXLSFile, url, "POST", payload, "");
}

export const WHAT_IF_CALCULATOR_GET_WHAT_IF_INFO = generateDefaultActions("WHAT_IF_CALCULATOR_GET_WHAT_IF_INFO");
export const getWhatIfInfo = payload => makePayload(WHAT_IF_CALCULATOR_GET_WHAT_IF_INFO.value, payload);
function* getWhatIfInfoSaga(payload) {
  yield put({ type: WHAT_IF_CALCULATOR_CLEAR_WHAT_IF_INFO.success });
  const url = "/getWhatIfInfo";
  yield requestSaga(WHAT_IF_CALCULATOR_GET_WHAT_IF_INFO, url, "POST", payload);
}

export const WHAT_IF_CALCULATOR_CLEAR_WHAT_IF_INFO = generateDefaultActions("WHAT_IF_CALCULATOR_CLEAR_WHAT_IF_INFO");
export const clearWhatIfInfo = payload => makePayload(WHAT_IF_CALCULATOR_CLEAR_WHAT_IF_INFO.value, payload);
function* clearWhatIfInfoSaga(payload) {
  yield put({ type: WHAT_IF_CALCULATOR_CLEAR_WHAT_IF_INFO.success });
}

// REDUCER

const initialState = {
  whatIfInfo: null
};

export function whatIfCalculatorReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case WHAT_IF_CALCULATOR_CLEAR_WHAT_IF_INFO.success:
      return { ...state, whatIfInfo: null };

    case WHAT_IF_CALCULATOR_EXPORT.success:
      ToastSuccess("Export Request Heard");

      return state;

    case WHAT_IF_CALCULATOR_GET_WHAT_IF_INFO.success:
      ToastInfo("What If Analysis Complete");
      if (payload.message !== "") {
        ToastError(payload.message);
      }

      return defaultReturn(state, payload, "whatIfInfo");

    case WHAT_IF_CALCULATOR_GET_WHAT_IF_INFO.failure:
      if (payload.message === "") {
        ToastError("What-If Calculator Error");
      }

      return state;

    default:
      return state;
  }
}

// SAGA

export function* whatIfCalculatorSaga() {
  yield takeLatest(WHAT_IF_CALCULATOR_EXPORT.value, exportWhatIfSaga);
  yield takeLatest(WHAT_IF_CALCULATOR_GET_WHAT_IF_INFO.value, getWhatIfInfoSaga);
  yield takeLatest(WHAT_IF_CALCULATOR_CLEAR_WHAT_IF_INFO.value, clearWhatIfInfoSaga);
}
